var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatFile = function SvgChatFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3348 12.9498L17.0602 22.0857C16.0466 23.8414 13.8035 24.4424 12.0478 23.4287C10.2922 22.4151 9.69113 20.1721 10.7048 18.4164L16.4381 8.48601C17.071 7.3897 18.4745 7.01364 19.5708 7.6466C20.6671 8.27956 21.0432 9.68302 20.4102 10.7793L15.5943 19.1208C15.342 19.5578 14.7781 19.7089 14.3412 19.4566C13.9042 19.2043 13.7531 18.6404 14.0054 18.2035L18.3627 10.6564L17.1711 9.96844L12.8137 17.5155C12.1808 18.6118 12.5568 20.0153 13.6532 20.6482C14.7495 21.2812 16.1529 20.9051 16.7859 19.8088L21.6019 11.4673C22.6155 9.71164 22.0145 7.4686 20.2588 6.45496C18.5031 5.44131 16.2601 6.04233 15.2464 7.79802L9.51313 17.7284C8.1188 20.1434 8.94478 23.2261 11.3598 24.6204C13.7749 26.0147 16.8575 25.1887 18.2519 22.7737L23.5265 13.6377L22.3348 12.9498Z",
    fill: "#8F97B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.0159,
    height: 22.0159,
    fill: "white",
    transform: "translate(11.9788 0.615234) rotate(30)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat_file.25e6f98c.svg";
export { ForwardRef as ReactComponent };